import { Button, Modal } from 'flowbite-react';
import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { BsBriefcaseFill } from 'react-icons/bs';
import { TiLocation } from 'react-icons/ti';

interface Props {
	isOpen?: boolean;
	onClose?: () => void;
}
const CreatePostionModal = ({ isOpen, onClose }: Props) => {
	const skills = [
		{
			key: 'javascript',
			value: 'Javascript',
		},
		{
			key: 'problemSolving',
			value: 'Problem Solving',
		},
		{
			key: 'css',
			value: 'CSS',
		},
	];
	return (
		<div className="flex flex-col rounded-[8px] bg-[#F7F9FB] shadow-[0px_-2px_16px_0px rgba(0,0,0,0.12)] py-[32px] px-[24px] gap-[22px]">
			<div className="rounded-[8px] bg-[#E5F0FF] py-[12px] px-[12px]">
				<p className="text-[#28293D] font-inter text-[16px] font-[500] leading-[24px]">
					Here are the details for the job based on your selected filters.
				</p>
			</div>
			<div className="flex flex-col rounded-[12px] border border-[#3E7BFA] bg-[#FFF] gap-[22px] py-[12px] px-[20px]">
				<div className="flex items-start gap-[16px]">
					<div className="w-full h-full max-w-[64px] max-h-[64px]">
						{/* this image be dynamic */}
						<img src={'/assets/amazonLogo.svg'} className="max-w-[48px] w-full h-full" alt="Amazon Logo" />
					</div>
					<div>
						<h6 className="text-[#28293D] font-inter text-[20px] font-[700] leading-[24px]">Full Stack Engineer</h6>
						<div className="flex gap-2 text-[#6698FA] items-center text-[12px] font-inter font-[500] leading-[24px]">
							Amazon <FiExternalLink />
						</div>
					</div>
				</div>
				<div className="flex flex-col gap-[10px]">
					<div className="flex gap-[4px] w-full">
						<BsBriefcaseFill className="text-[#00B7C4]" />
						<div className="flex gap-[4px]">
							<p className="text-[#28293D] font-inter font-[400] leading-[20px] text-[14px]">Full-Time</p>
							<p className="text-[#8F90A6] font-inter font-[500] leading-[16px] text-[12px]">•</p>
							<p className="text-[#28293D] font-inter font-[400] leading-[20px] text-[14px]">2+ yrs</p>
						</div>
					</div>

					<div className="flex gap-[4px]">
						<TiLocation className="text-[#00B7C4]" />
						<div className="flex justify-center items-center gap-[4px]">
							<p className="text-[#28293D] font-inter font-[400] leading-[20px] text-[14px]">Bengaluru</p>
							<p className="text-[#8F90A6] font-inter font-[500] leading-[16px] text-[12px]">•</p>
							<p className="text-[#28293D] font-inter font-[400] leading-[20px] text-[14px]">Remote</p>
						</div>
					</div>
				</div>
				<div className="flex flex-col items-start gap-[8px] pb-[35px]">
					<p className="text-[#8F90A6] font-inter font-[500] leading-[20px] text-[14px]">Skills required</p>
					<div className="gap-[12px] flex items-start justify-start flex-wrap">
						{skills.map(skill => (
							<div
								key={skill.key}
								className="py-[2px] px-[14px] text-[#555770] font-inter font-[500] leading-[21px] text-[14px] gap-[4px] rounded-[6px] border border-[#E2E8F0] bg-[#F8FAFC]"
							>
								{skill.value}
							</div>
						))}
					</div>
				</div>
			</div>
			<div className="flex w-full justify-end gap-[16px]">
				<Button color="light">Edit Details</Button>
				<Button color="purplePlaced">Confirm Job Details</Button>
			</div>
		</div>
	);
};

export default CreatePostionModal;
